/**
 * Service pour la gestion des paiements Stripe
 */
const API_BASE_URL = `${process.env.REACT_APP_API_URL}/api`;

export const stripePaymentService = {
    /**
     * Créer une session de paiement Stripe
     * @param {number} souscriptionId - ID de la souscription
     * @param {Object} options - URLs de redirection optionnelles
     * @returns {Promise} Réponse avec session_id et url_paiement
     */
    async creerPaiementEnLigne(souscriptionId, options = {}) {
        try {
            const response = await fetch(`${API_BASE_URL}/souscriptions/${souscriptionId}/paiement-en-ligne`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    success_url: options.success_url || null, // Laisser le backend gérer par défaut
                    cancel_url: options.cancel_url || null // Laisser le backend gérer par défaut
                })
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.detail || `Erreur HTTP: ${response.status}`);
            }

            const data = await response.json();
            return {
                success: true,
                data: data
            };
        } catch (error) {
            console.error('Erreur lors de la création du paiement en ligne:', error);
            return {
                success: false,
                error: error.message
            };
        }
    },

    /**
     * Vérifier le statut d'un paiement en ligne
     * @param {number} souscriptionId - ID de la souscription
     * @returns {Promise} Statut du paiement
     */
    async verifierStatutPaiement(souscriptionId) {
        try {
            const response = await fetch(`${API_BASE_URL}/souscriptions/${souscriptionId}/paiement-en-ligne/statut`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                }
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.detail || `Erreur HTTP: ${response.status}`);
            }

            const data = await response.json();
            return {
                success: true,
                data: data
            };
        } catch (error) {
            console.error('Erreur lors de la vérification du statut:', error);
            return {
                success: false,
                error: error.message
            };
        }
    },

    /**
     * Rediriger vers la page de paiement Stripe
     * @param {string} urlPaiement - URL de paiement Stripe
     */
    redirectVersStripe(urlPaiement) {
        if (!urlPaiement) {
            console.error('URL de paiement manquante');
            return;
        }

        // Redirection directe vers Stripe
        window.location.href = urlPaiement;
    },

    /**
     * Créer et rediriger vers Stripe en une seule opération
     * @param {number} souscriptionId - ID de la souscription
     * @param {Object} options - Options de paiement
     */
    async creerEtRedirigerVersStripe(souscriptionId, options = {}) {
        try {
            const result = await this.creerPaiementEnLigne(souscriptionId, options);

            if (result.success && result.data.url_paiement) {
                // Redirection immédiate vers Stripe
                this.redirectVersStripe(result.data.url_paiement);
                return result;
            } else {
                throw new Error(result.error || 'Impossible de créer le paiement');
            }
        } catch (error) {
            console.error('Erreur lors de la création et redirection:', error);
            return {
                success: false,
                error: error.message
            };
        }
    }
};

export default stripePaymentService;
